type Caption = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const caption: Caption = {
    'fontFamily': 'var(--plasma-typo-caption-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-caption-font-weight, 500)',
    'fontStyle': 'var(--plasma-typo-caption-font-style, normal)',
    'fontSize': 'var(--plasma-typo-caption-font-size, 0.75rem)',
    'letterSpacing': 'var(--plasma-typo-caption-letter-spacing, -0.0220em)',
    'lineHeight': 'var(--plasma-typo-caption-line-height, 1rem)'
};